const moduleHandler = (LocalStorage, roles) => {
  const { login, info } = LocalStorage.getLS();

  const info2 = (info === undefined)?{flHeadOffice:0}: info;

  const { flHeadOffice }  = info2;
  return roles[flHeadOffice];
}

export default moduleHandler;